import React from 'react'

const CellPhoneIcon = props => (
  <svg viewBox="0 0 9 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 0a1 1 0 00-1 1v3H2C.89 4 0 4.89 0 6v12c0 1.11.89 2 2 2h5c1.11 0 2-.89 2-2V6c0-.74-.4-1.38-1-1.72V1a1 1 0 00-1-1zM2 6h5v5H2V6zm1 7H2v1h1v-1zm1 0h1v1H4v-1zm3 0H6v1h1v-1zm-5 2h1v1H2v-1zm3 0H4v1h1v-1zm1 0h1v1H6v-1zm-3 2H2v1h1v-1zm1 0h1v1H4v-1zm3 0H6v1h1v-1z"
      fill="currentColor"
    />
  </svg>
)

export default CellPhoneIcon
